import React from 'react';
import { makeStyles, useTheme } from "@material-ui/core/styles";
// import TextField from '@material-ui/core/TextField';
// import clsx from "clsx";
import cache from 'memory-cache';
import RecordRTC from 'recordrtc';
// import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
// import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import {
  // Paper,
  // Button,
  Typography,
  // Table,
  // TableBody,
  // TableCell,
  // TableHead,
  // TableRow,
  // Grid,
  // AppBar,
  // Toolbar,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  // FormHelperText
} from '@material-ui/core';
// import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import SpeechToText from 'speech-to-text';
// import supportedLanguages from './supportedLanguages';
import Sentiment from 'sentiment';
// import emoji from 'node-emoji';
import axios from "../../../utils/axiosConfig";
import Cookies from 'js-cookie';
import DashboardGrid from '../../DashboardGrid/dashboardgrid';
import moment from 'moment';
import { Popover } from '@material-ui/core';
import { WEB_URL } from '../../../utils/constants';

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
 paper: {
      padding:'0px 5px',
    },
  popover: {
    pointerEvents: 'none',
  }
}));

export default (props) => {
  
  const classes = useStyles();
  const theme = useTheme();
  let token = Cookies.get('token');
  const { testData, questionNo, setClearFlag, clearFlag, examId, setCheckFlag, examDetail
    , answerStatus, setAnswerStatus, marksScored, setMarksScored, totalMarks, setTotalMarks,
    wrongAnswerCount, setWrongAnswerCount, disable, setDisable } = props;
  const [answer, setAnswer] = React.useState(testData[questionNo - 1].descriptiveText);
  const [error, setError] = React.useState(false);
  const [isRecording, setIsRecording] = React.useState(false);
  const [recordVideo, setRecordVideo] = React.useState(null);
  const [adminToken, setAdminToken] = React.useState('');
  const [interimText, setInterimText] = React.useState('');
  const [finalisedText, setFinalisedText] = React.useState([]);
  const [listening, setListening] = React.useState(false);
  const [language, setLanguage] = React.useState(examDetail[0].speechlang + '-IN');
  const [emojiValue, setEmojiValue] = React.useState(0);
  // const [src, setSrc] = React.useState(null); 
  // let listener;
  const [listener, setListener] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [userid, setUserId] = React.useState('');
  const [filename, setFilename] = React.useState('');
  const [blobUrl, setBlobUrl] = React.useState(`${WEB_URL}ah-resources/user-files/autoSpeech/` + filename);
  const [display, setDisplay] = React.useState(false);

  const [facialArray, setFacialArray] = React.useState('');
  const [big5, setBig5] = React.useState('');
  const [sentiment, setSentiment] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const onAnswerText = (text) => {
    setClearFlag(false);
    setCheckFlag(false);

    //  testData[questionNo -1].selectedChoiceId = text;
    let temp = answer;
    //temp[questionNo -1] = (e.target.value === testData[questionNo -1].choicetext) ? testData[questionNo -1].qmarks : 0;
    setAnswerStatus(temp);
    testData[questionNo - 1].answerStatus = (text == testData[questionNo - 1].choicetext) ? true : false;
    
    
    if (text !== '') {
      testData[questionNo - 1].buttonStyle = 'Answered';
      testData[questionNo - 1].descriptiveText = text;
      setError(false);
    } else {
      testData[questionNo - 1].buttonStyle = 'Not Answered';
      if (!examDetail[0].answermandatoryflag) {
        setError(true);
      }
    }

    // setAnswer(text);
  }

  function startRecord() {
    setDisplay(true);
    getUserMedia(async stream => {
      let recordVideo = RecordRTC(stream, { type: 'video' });
      setRecordVideo(recordVideo);
      

      await recordVideo.startRecording();
      startListening();
      axios({
        method: 'POST',
        url: `${WEB_URL}admin/ws/integration/authenticate`,
         headers: {
          'X-Username': 'admin@demo.com',
          'X-Password': 'admin@2020'
        }
      }).then(response => {
        
        setAdminToken(response.data.data.tokenId);
      }).catch(error => {
        
      })
    });
    setIsRecording(true)
  }

  function stopRecord() {
    setDisplay(false);
    recordVideo.stopRecording(() => {
      //this.state.recordVideo.save();
      
      setIsRecording(false)
      setBlobUrl(URL.createObjectURL(recordVideo.getBlob()));
      stopListening();
      var formData = new FormData();
      formData.append('file', recordVideo.getBlob(), filename);
      formData.append('userId', userid);
      formData.append('uname', firstName + ' ' + lastName);
      formData.append('ufilename', filename);
      formData.append('facialArray', facialArray.toString());
      formData.append('big5', big5.toString());
      formData.append('sentiment', sentiment.toString());

      axios({
        method: 'POST',
        url: `${WEB_URL}admin/ws/integration/v3/videoFile`,
        // url: 'http://192.168.31.35:8080/admin/ws/integration/v3/videoFile',
        data: formData,
        headers: {
          'X-Auth-Token': adminToken,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        
      }).catch(error => {
        
      })
    });
  }
  function getUserMedia(callback) {
    
    navigator.getUserMedia({ audio: true, video: true }, callback, error => alert(JSON.stringify(error)));
  }

  // function requestUserMedia(){
  //   getUserMedia(stream => {
  //   setSrc(window.URL.createObjectURL(stream) );
  //   });
  //   }
  const onAnythingSaid = text => {
    setInterimText(text);
  };

  const onEndEvent = () => {
    if (listening) {
      startListening();
    } else {
      setListening(false);
    }
  };

  const onFinalised = text => {

    setFinalisedText([text, ...finalisedText]);
    setAnswer(answer + ' ' + text)
    setInterimText('')

    const sentiment = new Sentiment();
    const result = sentiment.analyze(text);
    setEmojiValue(result.score);
    //  getBigFive(text);
    

    onAnswerText(text);
  };

  const startListening = () => {
    try {
      let listener = new SpeechToText(
        onFinalised,
        onEndEvent,
        onAnythingSaid,
        language
      );
      setListener(listener);
      

      listener.startListening();
      setListening(true);
    } catch (err) {
      
      
    }
  };

  const stopListening = () => {
    listener.stopListening();
    setListening(false);
  };

  // getBigFive = (text) => {
  //   return new Promise(async(resolve, reject) => {
  //     try {
  //       if(text !== null && text !== ''){
  //         let predictions = await axios.get(`https://www.assesshub.com/predict/${text}`);
  //         
  //         

  //         let big5 = await [parseInt(parseFloat(predictions.data.pred_prob_cOPN).toFixed(2) * 100),
  //           parseInt(parseFloat(predictions.data.pred_prob_cCON).toFixed(2) *100),
  //           parseInt(parseFloat(predictions.data.pred_prob_cEXT).toFixed(2) * 100),
  //           parseInt(parseFloat(predictions.data.pred_prob_cAGR).toFixed(2) * 100),
  //           parseInt(parseFloat(predictions.data.pred_prob_cNEU).toFixed(2) *100)];
  //        // await this.setState({big5})
  //         await setBig5Value(big5)
  //         

  //       }else{
  //         

  //         let big5 = await [25, 66, 45, 80, 20];
  //         await setBig5Value({big5})
  //        // await this.setState({big5});
  //       }
  //       resolve({});

  //     } catch (error) {
  //       
  //       reject(error);
  //     }
  //   })
  // }
  React.useEffect(() => {
    
    if (questionNo === testData.length) {
      

      setDisable(true);
    }
    try {
      axios.get('/v3/dashboard/getProfile', {
        headers: {
          'Access-Control-Allow-Origin': '*',
        }
      }).then(profData => {
        
        let userData = profData.data.profileData;
        setFirstName(userData.firstname);
        setLastName(userData.lastname);
        // setContactNo(userData.contact_number);
        // setUserInfoId(userData.id);
        // setEmail(userData.email_address);
        setUserId(userData.userid);
        setFilename(`${questionNo}-${testData[questionNo - 1].qid}-${props.examId}-${userData.userid}-${moment().format('DD-MM-YYYY')}.webm`);
      }).catch(error => {
        
      })
    } catch (error) {
      
    }
    //setAnswer(testData[questionNo -1].descriptiveText);
    testData[questionNo - 1].answerResourcePath = filename;
    testData[questionNo - 1].descriptiveText = answer;
    setBlobUrl(`${WEB_URL}ah-videoFile/videoInterview/${userid}/${props.examId}/` + filename);

    
    if (clearFlag) {
      //  testData[questionNo -1].selectedChoiceId = "";
      testData[questionNo - 1].descriptiveText = "";

      let temp = answer;
      //temp[questionNo -1] = 0;
      setAnswerStatus(temp);
      
      setAnswer("");
      testData[questionNo - 1].buttonStyle = 'Not Answered';
      let collectData = {quesData: testData, examDetail: examDetail}
      let encode = encodeURIComponent(btoa(encodeURIComponent(JSON.stringify(collectData))))
      window.localStorage.setItem(examId, encode);
      
      setClearFlag(false);
    }
    // requestUserMedia();
  }, [clearFlag, answer, blobUrl, finalisedText, filename, questionNo])

  return (
    <div>
      <>
        {/* <strong> Question No {questionNo}</strong>< br/>  */}
        <Typography
          aria-owns={open ? 'mouse-over-popover' : undefined}
          aria-haspopup="true"
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
        <span className="question-num">Q .{questionNo} of {testData.length}</span>
        </Typography>
        {/* <Button> Question No {questionNo}</Button>< br/>  */}
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper,
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Typography>{testData[questionNo - 1].qid}</Typography>
        </Popover>
        <span dangerouslySetInnerHTML={{ __html: testData[questionNo - 1].qtext }} />
        {
          testData[questionNo - 1].qresourcepath !== '' ?
            <>  <br />
              <br />
              <audio src={`${WEB_URL}ah-resources/questionimages/` + testData[questionNo - 1].qresourcepath} controls="controls" />
            </>
            : <></>
        }
        <br />
        <br />

        {
          !isRecording
            ?
            <>
              <p>Click below button to start recording</p>
              <img src={`${WEB_URL}images/rec_start.png`}
                onClick={() => startRecord()} />
              {/* <PlayCircleFilledIcon  */}
            </>
            :
            <>
              <p>Click below button to stop recording</p>
              <img src={`${WEB_URL}images/rec_stop.png`}
                onClick={() => stopRecord()} />
              {/* <PauseCircleFilledIcon  */}
            </>
        }


      </>
      { display ?
        <DashboardGrid themeType={props.themeType} setFacialArray={setFacialArray} setBig5={setBig5} setSentiment={setSentiment}
        />


        : <></>

      }
    </div>
  )
}